/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IMedicine } from 'app/shared/model/medicine.model';
import { IFrequency } from 'app/shared/model/frequency.model';
import { ISequence } from 'app/shared/model/sequence.model';
import { IDosageGuideline } from 'app/shared/model/dosage-guideline.model';
import { IRegimenCycle } from 'app/shared/model/regimen-cycle.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';

export interface IRegimenDrug {
  id?: string;
  drugClass?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  drug?: IMedicine | null;
  frequency?: IFrequency | null;
  sequence?: ISequence | null;
  dose?: IDosageGuideline | null;
  cycle?: IRegimenCycle | null;
  medicationType?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IRegimenDrug> = {
  active: false,
};
